import { useCallback } from 'react';

import api from '@/services/api';
import { PaymentAccountSession } from '@/types/payment-account';

/**
 * `POST /payment-account/session` (T1.5, T4.4). Fica fora do React Query de
 * propósito: não é dado para exibir nem para cachear — é um segredo de
 * passagem que os componentes do Stripe (web e nativo) usam uma vez e
 * descartam. Cada chamada cria uma `AccountSession` nova (sem idempotency
 * key, de propósito — plano, seção 2.6/4.2); nunca reaproveita a anterior,
 * nunca loga nem guarda o `clientSecret` em estado, `AsyncStorage` ou URL.
 */
export function usePaymentAccountSession() {
  const fetchSession = useCallback(
    async () => (await api.post<PaymentAccountSession>('/payment-account/session')).data,
    [],
  );

  /**
   * Repassado direto a `loadConnectAndInitialize` (web e nativo): o SDK
   * chama isto na primeira vez e de novo sempre que a sessão expira.
   */
  const fetchClientSecret = useCallback(async () => {
    const session = await fetchSession();
    return session.clientSecret;
  }, [fetchSession]);

  return { fetchSession, fetchClientSecret };
}
